module.exports = __webpack_public_path__ + "assets/overview-campaign.9c276545.svg";